var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings" }, [
    _c("p", { staticClass: "lead" }, [_vm._v("設定")]),
    _vm._v(" "),
    _c("div", { staticClass: "settings__item settingCategory" }, [
      _c("p", { staticClass: "settings__item__title" }, [_vm._v("カテゴリ")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.categoryId,
              expression: "categoryId"
            }
          ],
          staticClass: "esModalCategory",
          attrs: { id: "esSettingsCategory" },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.categoryId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.trackCategory
            ]
          }
        },
        _vm._l(_vm.categoryData, function(articleCategory) {
          return _c(
            "option",
            { domProps: { value: articleCategory.categoryId } },
            [
              _vm._v(
                _vm._s(articleCategory.categoryName) +
                  " (" +
                  _vm._s(articleCategory.contentCount) +
                  ")\n      "
              )
            ]
          )
        })
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonDialogPosition" }, [
      _c(
        "button",
        { staticClass: "button large", on: { click: _vm.submitEvent } },
        [_vm._v("保存")]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "close-button",
        attrs: { "aria-label": "Close modal", type: "button" },
        on: { click: _vm.close }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }